import {Component, h, Fragment} from "preact";
import {Modal} from "../../_common/components/modal";
import {t} from "../../_i18n";
import {E, R, FR} from "../../_common/layout";
import {RadioCheckbox} from "../../_common/forms/components/components";
import {AcademicProgram, State} from "../../_api";
import {AppPage} from "../../_common/components/app-page";
import {connect} from "react-redux";
import {fetchAcademicPrograms, fetchCompanyOffersCount, fetchOffers, fetchStates} from "../../_rx/jobs/actions";
import {OFFERS_LIMIT_PAGES} from "../../constants";

const modality: {[key:string]: string} = {
    'normal': t('Oferta de trabajo'),
    'fct': t('Formación en centro de trabajo (FCT)'),
    'dual': t('Dual')
}

const initialState = {
    modality: {},
    academicPrograms: {},
    states: {}
}

type Props = {
    id: string,
    states: State[],
    academicPrograms: AcademicProgram[],
    fetchOffers: any,
    fetchCompanyOffersCount: typeof fetchCompanyOffersCount,
    companyOffersCount: any,
    companyOffersFilter: any,
    status: number,
    page: any,
    history: any,
    handleFilter: any,
    showModal: any,
    handleCloseFilter: any
}

type StateReact = {
    modality: any,
    academicPrograms: any,
    states: any
}


class View extends Component<Props, StateReact> {

    constructor(props: any) {
        super(props);
        this.state = initialState;
    }

    renderOffersNum = (offersNum: number) => {
        let text: string = '';
        if (offersNum === 1) {
            text = offersNum + " " + t("oferta")
        } else if (offersNum > 1 || offersNum === 0){
            text = offersNum + " " + t("ofertas")
        }
        return text;
    }

    initializeObjectToSend = (ob: any = false) => {
        const statesArray: any = [];
        const academicProgramsArray: any = [];
        const modalityArray: any = [];
        let modality = this.state.modality;
        let states = this.state.states;
        let academicPrograms = this.state.academicPrograms;

        if (ob) {
            modality = ob.modality;
            states = ob.states;
            academicPrograms = ob.academicPrograms;
        }

        Object.keys(modality).filter(modalityItem => (modality[modalityItem])
            && modalityArray.push(modalityItem));
        Object.keys(states).filter(statesItem => (states[statesItem])
            && Object.keys(this.props.states).find((key: any) => (this.props.states[key] === statesItem) && statesArray.push(key)));
        Object.keys(academicPrograms).filter(academicProgramsItem => (academicPrograms[academicProgramsItem])
            && Object.keys(this.props.academicPrograms).find((key: any) => (this.props.academicPrograms[key] === academicProgramsItem) && academicProgramsArray.push(key)));

        let objectToSend = {}
        if (modalityArray.length > 0){
            objectToSend = {...objectToSend, modalities: modalityArray.join(",")}
        }
        if (statesArray.length > 0){
            objectToSend = {...objectToSend, states: statesArray.join(",")}
        }
        if (academicProgramsArray.length > 0) {
            objectToSend = {...objectToSend, academicPrograms: academicProgramsArray.join(",")}
        }

        return objectToSend;
    }

    async updateNumberOffers ({modality, states, academicPrograms}: any) {
        let objectToSend = this.initializeObjectToSend({modality, states, academicPrograms});
        await this.props.fetchCompanyOffersCount({status: this.props.status, limit: OFFERS_LIMIT_PAGES, ...objectToSend});
    }

    submitFilter = () => {
       let objectToSend = this.initializeObjectToSend();
       this.props.handleFilter(objectToSend);
    }

    render = ({id, companyOffersFilter, showModal, companyOffersCount}: Props) => showModal && <Modal id={id} title={t('Filtrar ofertas')} className="md-no-fullscreen" withHeaderTitle>
        <div className="in-modal-scroll sm-p-x2-left sm-p-x2-right p-right p-left">
            {console.log(companyOffersCount)}
            {companyOffersFilter.showModalities &&
                <Fragment>
                        <FR>
                            <E className='t-left sm-p-top'>
                                <h3>{t('Tipo de oferta')}</h3>
                            </E>
                        </FR>

                        <FR className="sm-row-2-el row-1-el">
                            {(companyOffersFilter.modalityList).map((Key: any) => (Key['label'] !== "dual") && <E className='t-left'>
                                    <RadioCheckbox name={modality[Key['label']]}
                                                   type="checkbox"
                                                   defaultValue={(this.state.modality[Key['label']]) ? this.state.modality[Key['label']] : false}
                                                   label={modality[Key['label']]}
                                                   onChange={(val: boolean) => {
                                                       const modality = {...this.state.modality, [Key['label']]: val}
                                                       this.setState({
                                                           modality: modality
                                                       });
                                                       this.updateNumberOffers({modality, states: this.state.states, academicPrograms: this.state.academicPrograms});
                                                   }}
                                    />
                                </E>
                            )}
                        </FR>
                </Fragment>
            }
            {companyOffersFilter.showStates &&
                <Fragment>
                    {companyOffersFilter.showModalities && <hr className="separator-xxs"/>}
                    <FR>
                        <E className='t-left sm-p-top'>
                            <h3>{t('Provincia')}</h3>
                        </E>
                    </FR>
                    <FR className="sm-row-3-el row-1-el">
                        {(companyOffersFilter.stateList).map((key: any) => {
                                const label: any = key['name'];
                                return <E className='t-left sm-no-margin-bottom'>
                                    <RadioCheckbox name={label}
                                                   type="checkbox"
                                                   label={t(label)}
                                                   defaultValue={(this.state.states[label]) ? this.state.states[label] : false}
                                                   onChange={(val: boolean) => {
                                                       const states = {
                                                           ...this.state.states,
                                                           [label]: val
                                                       }
                                                       this.setState({
                                                           states: states
                                                       });
                                                       this.updateNumberOffers({modality: this.state.modality, states, academicPrograms: this.state.academicPrograms});
                                                   }}
                                    />
                                </E>
                            }
                        )}
                    </FR>
                </Fragment>
            }
            {companyOffersFilter.showAcademicProgramScopes &&
                <Fragment>
                    {(companyOffersFilter.showStates || companyOffersFilter.showModalities) && <hr className="separator-xxs"/>}
                    <FR>
                        <E className='t-left sm-p-top'>
                            <h3>{t('Titulación')}</h3>
                        </E>
                    </FR>
                    <R>
                        {(companyOffersFilter.academicProgramScopeList).map((key: any) => {
                                const label: any = key['name'];
                                return <E className='t-left sm-no-margin-bottom'>
                                    <RadioCheckbox name={label}
                                                   type="checkbox"
                                                   label={t(label)}
                                                   defaultValue={(this.state.academicPrograms[label]) ? this.state.academicPrograms[label] : false}
                                                   onChange={(val: boolean) => {
                                                       const academicPrograms = {
                                                           ...this.state.academicPrograms,
                                                           [label]: val
                                                       }
                                                       this.setState({
                                                           academicPrograms: academicPrograms
                                                       });
                                                       this.updateNumberOffers({modality: this.state.modality, states: this.state.states, academicPrograms});
                                                   }}
                                    />
                                </E>
                            }
                        )}
                    </R>
                </Fragment>
            }
        </div>
        <hr className="separator-xxs"/>
        <FR className="sm-row-2-el row-1-el modal-footer-padding flex-center-y">
            <E className="t-center sm-no-t-center">
                <button className="btn btn-primary" type='button' onClick={() => this.submitFilter()}>
                    {companyOffersCount && t('Mostrar ' + this.renderOffersNum(companyOffersCount.count))}
                </button>
            </E>
            <E className='t-center sm-t-right'>
                <a className="txt-color-primary font-14 t-underline" onClick={() => {this.setState(initialState);  this.updateNumberOffers(initialState);}}>{t('QUITAR FILTROS')}</a>
            </E>
        </FR>
    </Modal>


}

const ConnectedView: any = connect(
    ({offers, fixtures, companyOffersCount}: any)=>({offers, fixtures, companyOffersCount}), {fetchOffers, fetchCompanyOffersCount})(View as any);


export default ({id, states, academicPrograms, companyOffersFilter, status, history, handleFilter, showModal, handleCloseFilter, ...props}: any) =>
        <ConnectedView id={id} states={states} companyOffersFilter={companyOffersFilter} academicPrograms={academicPrograms} status={status} history={history} handleFilter={handleFilter} showModal={showModal} handleCloseFilter={handleCloseFilter}/>
;
